import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;

  @media (max-width: 991px) {
    max-width: 100%;
    margin: 0 auto;
    padding-left: 30px;
    padding-right: 30px;
  }

  @media (min-width: 0px) and (max-width: 767px){
    padding-left:15px;
    padding-right:15px;
  }
  @media (max-width:575px){
      max-width:540px;
  }
`;

export default Container;
